import { render, staticRenderFns } from "./MyNotice.vue?vue&type=template&id=0180c81c&"
import script from "./MyNotice.vue?vue&type=script&lang=js&"
export * from "./MyNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports